module.exports = __webpack_public_path__ + "static/img/bh.98f38deb.png";